export default "__VITE_ASSET__CPNYcdnd__"